import { Components, Theme } from '@mui/material';
import { wbTheme } from '@workbuzz/shared-ui';

import { BLACK, WHITE } from '../colors';

export const MuiTooltipStyles: Components<Omit<Theme, 'components'>> = {
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        ...wbTheme.typography.subtitle2,
        backgroundColor: BLACK,
        borderRadius: '4px',
        padding: '10px 16px',
        maxWidth: 500,
        color: `${WHITE} !important`,
        textAlign: 'center',
      },
      popper: {
        ...wbTheme.typography.subtitle2,
        color: WHITE,
      },
      arrow: {
        color: BLACK,
      },
    },
  },
};
